/* Sharrow homepage scripts (converted from Squarespace). */

/* Keep a background video covering its box at any size. */
(function(){
  function cover(box, prefix){
    if(!box || box.dataset.coverReady==='1') return;
    box.dataset.coverReady='1';
    const fit=()=>{
      const r=box.getBoundingClientRect();
      if(r.width<=0||r.height<=0) return;
      const w=Math.max(r.width,r.height*16/9);
      box.style.setProperty(prefix+'-cover-width',w+'px');
      box.style.setProperty(prefix+'-cover-height',(w*9/16)+'px');
    };
    fit();
    if('ResizeObserver' in window) new ResizeObserver(fit).observe(box);
    else window.addEventListener('resize',fit,{passive:true});
  }
  window.SharrowCoverVideo=cover;
})();

(function(){
  function initSharrowHome(){
(function(){
 const heroCopy=document.querySelector('.cinematic-hero-copy');
 if(heroCopy){
   heroCopy.style.removeProperty('transform');
   heroCopy.style.removeProperty('opacity');
   heroCopy.style.removeProperty('filter');
 }

 const els=document.querySelectorAll('.fade');
 const io=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('on')})},{threshold:.12});
 els.forEach(el=>io.observe(el));
 const gregCaption=document.querySelector('[data-greg-caption]');
 if(gregCaption){
   const captionIO=new IntersectionObserver(entries=>{
     entries.forEach(entry=>{if(entry.isIntersecting) gregCaption.classList.add('on');});
   },{threshold:.38});
   captionIO.observe(gregCaption);
 }

 const experienceRoot=document.getElementById('benefit-experience');
 if(experienceRoot){
   const quoteLibrary={
     range:[
       {quote:'Saving as much as 40 gallons of gasoline on our typical offshore trip.',customer:'Jon A. / 36’ Twin Vee'},
       {quote:'I was able to extend my mileage by around 60 miles per tank.',customer:'Wil C. / Ranger Tug R-25 Classic'},
       {quote:'Greater range, better fuel economy, and enhanced throttle response.',customer:'Bill G. / Contender 35ST'},
       {quote:'Fuel per hour hardly changed, giving us great extra range.',customer:'Greg G. / 7.8m Kiwi Kraft'},
       {quote:'The fuel savings helps justify it for commercial use.',customer:'Craig H. / 36 Munson'}
     ],
     fuel:[
       {quote:'Fuel consumption was down at least 25%.',customer:'Russell M. / Crownline LS210'},
       {quote:'We hit our target with a 12 to 14% savings in fuel.',customer:'Ben F. / 38’ Aluminum Fish Boat'},
       {quote:'At midrange speeds the fuel savings was exceptional.',customer:'Bill G. / Contender 35ST'},
       {quote:'Fuel has dropped from 29.5 liters to 25 liters.',customer:'Greg G. / 7.8m Kiwi Kraft'},
       {quote:'Save 20% on fuel while increasing the hole shot.',customer:'Tom Nelson / 710 ESPN Seattle'}
     ],
     cruise:[
       {quote:'I’ve gone from 3550 RPM to 3000 RPM.',customer:'Greg G. / 7.8m Kiwi Kraft'},
       {quote:'I can maintain 15 to 20 MPH without constantly adjusting the throttles.',customer:'Normand C. / SeaHunter 33T'},
       {quote:'Plane slower as well, which really helps in big water.',customer:'Craig H. / 36 Munson'},
       {quote:'At 2500 RPM, the speed increased with SHARROW™ by 42%.',customer:'Niels M. / Harris Grand Mariner'},
       {quote:'Comfortable cruising speeds were 35 MPH at around 3500 RPM.',customer:'Russell M. / Crownline LS210'}
     ],
     vibration:[
       {quote:'Much, much lower vibration.',customer:'Fred G. / Bryant 220'},
       {quote:'Vibration was significantly reduced.',customer:'Russell M. / Crownline LS210'},
       {quote:'The boat is smoother and quieter.',customer:'Lynn M. / Jeanneau NC 895'},
       {quote:'Smoother at cruise and better around the dock.',customer:'Neal T. / Grady White 251'},
       {quote:'It made the boat quieter and smoother.',customer:'Brian M. / Robalo 301'}
     ],
     noise:[
       {quote:'Quieter and much, much lower vibration.',customer:'Fred G. / Bryant 220'},
       {quote:'The boat is smoother and quieter.',customer:'Lynn M. / Jeanneau NC 895'},
       {quote:'Less noise and vibration.',customer:'Gene B. / 32’ Boston Whaler'},
       {quote:'It made the boat quieter and smoother.',customer:'Brian M. / Robalo 301'}
     ],
     different:[
       {quote:'Now I love the boat!',customer:'Gene B. / 32’ Boston Whaler'},
       {quote:'I’ll never go back to my standard setup!',customer:'John G. / Harris Grand Mariner'},
       {quote:'They really did build a better mousetrap.',customer:'Normand C. / SeaHunter 33T'},
       {quote:'Best thing I’ve ever installed on this boat. I love it.',customer:'Bill R. / Hydra Sports 230WA'},
       {quote:'SHARROW™ performance exceeded my expectations.',customer:'Russell M. / Crownline LS210'}
     ],
     plane:[
       {quote:'My boat planed quicker at a lower RPM.',customer:'Heber S. / 25’ Sea Cat'},
       {quote:'Plane speed reduced from the mid 20 MPH range to 20 MPH.',customer:'Russell M. / Crownline LS210'},
       {quote:'The boat got up on plane at a lower speed and RPM.',customer:'Bill G. / Contender 35ST'},
       {quote:'Pulling skiers was much improved with noticeably quicker hole shot.',customer:'Russell M. / Crownline LS210'},
       {quote:'Gets on plane faster and gets better MPG.',customer:'Mark T. / Robalo 272'}
     ],
     handling:[
       {quote:'Handling was improved immensely.',customer:'Russell M. / Crownline LS210'},
       {quote:'There is a strong feeling of control and better tracking in moderate seas.',customer:'Gene B. / 32’ Boston Whaler'},
       {quote:'Dramatically improved performance and handling.',customer:'Bill R. / Hydra Sports 230WA'},
       {quote:'The boat has this feel of consistency.',customer:'Normand C. / SeaHunter 33T'},
       {quote:'More responsive.',customer:'Brian M. / Robalo 301'}
     ],
     control:[
       {quote:'Docking was significantly easier.',customer:'Russell M. / Crownline LS210'},
       {quote:'Maneuvers much better in the marinas.',customer:'Bill R. / Hydra Sports 230WA'},
       {quote:'The improved boat handling around the dock is amazing.',customer:'Neal T. / Grady White 251'},
       {quote:'Better handling at low speeds.',customer:'John G. / 25’ Pontoon'},
       {quote:'A strong feeling of control and better tracking in moderate seas.',customer:'Gene B. / 32’ Boston Whaler'}
     ]
   };

   const tabs=[...experienceRoot.querySelectorAll('.experience-tab')];
   const benefits=[...experienceRoot.querySelectorAll('.experience-benefit')];
   const selectorKicker=document.getElementById('experienceSelectorKicker');
   const stage=document.getElementById('experienceStage');
   const stageImage=document.getElementById('experienceStageImage');
   const groupLabel=document.getElementById('experienceGroupLabel');
   const title=document.getElementById('experienceTitle');
   const description=document.getElementById('experienceDescription');
   const statCard=document.getElementById('experienceStatCard');
   const stat=document.getElementById('experienceStat');
   const unit=document.getElementById('experienceUnit');
   const statLabel=document.getElementById('experienceStatLabel');
   const reportBoat=document.getElementById('experienceReportBoat');
   const reportResult=document.getElementById('experienceReportResult');
   const reportButton=document.getElementById('experienceReportButton');
   const quoteTrack=document.getElementById('experienceQuoteTrack');
   const quoteCount=document.getElementById('experienceQuoteCount');
   const position=document.getElementById('experiencePosition');
   const positionBar=document.getElementById('experiencePositionBar');
   let activeGroup='farther';
   let changeTimer=null;

   const visibleBenefits=()=>benefits.filter(button=>button.dataset.group===activeGroup);
   const groupName=group=>tabs.find(tab=>tab.dataset.experienceGroup===group)?.dataset.label || group;

   const renderQuotes=(key,label)=>{
     const items=quoteLibrary[key] || [];
     quoteTrack.replaceChildren();
     items.forEach(item=>{
       const card=document.createElement('blockquote');
       card.className='experience-customer-quote';
       const text=document.createElement('p');
       text.textContent='“'+item.quote+'”';
       const cite=document.createElement('cite');
       cite.textContent=item.customer;
       card.append(text,cite);
       quoteTrack.append(card);
     });
     quoteCount.textContent=items.length+' customer quote'+(items.length===1?'':'s');
     quoteTrack.setAttribute('aria-label','Customer quotes for '+label);
     quoteTrack.scrollTo({left:0,behavior:'auto'});
   };

   const renderBenefit=(button,animate=true)=>{
     if(!button) return;
     window.clearTimeout(changeTimer);
     visibleBenefits().forEach(item=>{
       const selected=item===button;
       item.classList.toggle('is-active',selected);
       item.setAttribute('aria-pressed',String(selected));
     });
     const siblings=visibleBenefits();
     const index=Math.max(0,siblings.indexOf(button));
     const apply=()=>{
       stage.dataset.tone=button.dataset.tone || activeGroup;
       groupLabel.textContent=groupName(activeGroup);
       title.textContent=button.dataset.title || '';
       description.textContent=button.dataset.description || '';
       stat.textContent=button.dataset.stat || '';
       unit.textContent=button.dataset.unit || '';
       statLabel.textContent=button.dataset.statLabel || '';
       statCard.classList.toggle('is-word',button.dataset.statType==='word');
       reportBoat.textContent=button.dataset.report || '';
       reportResult.textContent=button.dataset.reportResult || '';
       reportButton.href=button.dataset.reportLink || reportButton.href;
       position.textContent=String(index+1).padStart(2,'0');
       positionBar.style.transform=`translateX(${index*100}%)`;
       renderQuotes(button.dataset.key,button.dataset.title || 'selected benefit');
       if(stageImage){
         const nextImage=button.dataset.image;
         if(nextImage && stageImage.getAttribute('src')!==nextImage) stageImage.setAttribute('src',nextImage);
         stageImage.style.objectPosition=button.dataset.position || 'center';
         stageImage.alt=button.dataset.alt || '';
       }
       stage.classList.remove('is-changing');
     };
     if(animate){
       stage.classList.add('is-changing');
       changeTimer=window.setTimeout(apply,145);
     }else apply();
   };

   const activateGroup=(group,focusFirst=false)=>{
     activeGroup=group;
     tabs.forEach(tab=>{
       const selected=tab.dataset.experienceGroup===group;
       tab.classList.toggle('is-active',selected);
       tab.setAttribute('aria-selected',String(selected));
       tab.tabIndex=selected?0:-1;
     });
     benefits.forEach(button=>{
       const visible=button.dataset.group===group;
       button.hidden=!visible;
       if(!visible){
         button.classList.remove('is-active');
         button.setAttribute('aria-pressed','false');
       }
     });
     if(selectorKicker) selectorKicker.textContent=groupName(group);
     const first=visibleBenefits()[0];
     renderBenefit(first,true);
     if(focusFirst) window.requestAnimationFrame(()=>first?.focus({preventScroll:true}));
   };

   tabs.forEach((tab,index)=>{
     tab.addEventListener('click',()=>activateGroup(tab.dataset.experienceGroup));
     tab.addEventListener('keydown',event=>{
       if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
       event.preventDefault();
       let next=index;
       if(event.key==='ArrowRight') next=(index+1)%tabs.length;
       if(event.key==='ArrowLeft') next=(index-1+tabs.length)%tabs.length;
       if(event.key==='Home') next=0;
       if(event.key==='End') next=tabs.length-1;
       tabs[next].focus();
       activateGroup(tabs[next].dataset.experienceGroup);
     });
   });

   benefits.forEach(button=>{
     button.addEventListener('click',()=>renderBenefit(button,true));
     button.addEventListener('keydown',event=>{
       if(!['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
       const items=visibleBenefits();
       const index=items.indexOf(button);
       if(index<0) return;
       event.preventDefault();
       let next=index;
       if(event.key==='ArrowDown'||event.key==='ArrowRight') next=(index+1)%items.length;
       if(event.key==='ArrowUp'||event.key==='ArrowLeft') next=(index-1+items.length)%items.length;
       if(event.key==='Home') next=0;
       if(event.key==='End') next=items.length-1;
       items[next].focus();
       renderBenefit(items[next],true);
     });
   });

   experienceRoot.querySelectorAll('.experience-quote-control').forEach(control=>{
     control.addEventListener('click',()=>{
       const direction=Number(control.dataset.quoteDirection)||1;
       quoteTrack.scrollBy({left:direction*Math.max(240,quoteTrack.clientWidth*.76),behavior:'smooth'});
     });
   });

   if(stageImage){
     stageImage.addEventListener('error',()=>{
       stageImage.src='/cdn/shop/files/sharrow-site-0df1ff2e-pursuit-s-328.jpeg';
     },{once:true});
   }

   renderBenefit(visibleBenefits()[0],false);
 }


 document.querySelectorAll('#interactiveLineup .lineup-card').forEach(card=>{
   card.addEventListener('click',()=>{
     const root=document.getElementById('interactiveLineup');
     if(!root) return;
     root.querySelectorAll('.lineup-card').forEach(c=>c.classList.remove('active'));
     card.classList.add('active');
     const set=(id,val)=>{const el=document.getElementById(id); if(el) el.textContent=val;};
     set('stageKicker',card.dataset.kicker||'');
     set('stageTitle',card.dataset.title||'');
     set('stageText',card.dataset.text||'');
     set('stageUse',card.dataset.use||'');
     set('stagePower',card.dataset.power||'');
     set('stageFeel',card.dataset.feel||'');
     const img=document.getElementById('stageImage');
     if(img){img.src=card.dataset.img; img.alt=(card.dataset.title||'SHARROW product')+' image';}
     const link=document.getElementById('stageLink');
     if(link) link.href=card.dataset.link||link.href;
   });
 });
})();

(function(){
  const root = document.getElementById('interactiveLineup');
  if (!root) return;
  const stage = root.querySelector('.lineup-stage');
  const list = root.querySelector('.lineup-list');
  const stageImage = document.getElementById('stageImage');
  if (!stage || !list) return;

  const syncProductRailHeight = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    if (isMobile) {
      root.style.removeProperty('--lineupRailHeight');
      return;
    }
    const stageHeight = Math.ceil(stage.getBoundingClientRect().height);
    if (stageHeight > 0) {
      root.style.setProperty('--lineupRailHeight', stageHeight + 'px');
    }
  };

  syncProductRailHeight();
  window.addEventListener('load', syncProductRailHeight);
  window.addEventListener('resize', syncProductRailHeight);

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(syncProductRailHeight);
    ro.observe(stage);
  }

  if (stageImage) {
    stageImage.addEventListener('load', syncProductRailHeight);
  }

  root.querySelectorAll('.lineup-card').forEach(card => {
    card.addEventListener('click', () => {
      window.requestAnimationFrame(syncProductRailHeight);
      window.setTimeout(syncProductRailHeight, 180);
    });
  });
})();

(function(){
  const root=document.getElementById('home-find-my-boat');
  if(!root||root.dataset.ready==='1') return;
  root.dataset.ready='1';
  const brands=[["ACI Boats","b"],["Air-Craft Boats","b"],["Albemarle Boats","b"],["Albury Brothers Boats","b"],["Allied Boats","b"],["Alumacraft","b"],["Alweld Boats","b"],["Andros Boatworks","b"],["Aquila Power Catamarans","b"],["ArrowCat","b"],["Avalon Pontoons","b"],["Axopar","b"],["Back Cove Yachts","b"],["Bahama Boatworks","b"],["Baja Marine","b"],["Barker Boatworks","b"],["Barletta Boats","b"],["Bay Welding Boats","b"],["Bayliner","b"],["Beneteau","b"],["Bennington","b"],["Bertram Yachts","b"],["Blackfin","b"],["Blue Wave Boats","b"],["Boston Whaler","b"],["BRABUS Marine","b"],["Buddy Davis","b"],["Calcutta Boats","b"],["Campion","b"],["Cape Horn","b"],["Carolina Skiff","b"],["Caymas Boats","b"],["Celebrity Boats","b"],["Chaparral Boats","b"],["Checkmate Powerboats","b"],["Cheetah Marine","b"],["Chris-Craft","b"],["Cigarette Racing","b"],["Cobalt Boats","b"],["Cobia Boats","b"],["Concept Boats","b"],["Contender Boats","b"],["Cox Marine","e"],["Crest Pontoons","b"],["Crestliner","b"],["Crownline","b"],["Cruisers Yachts","b"],["Cutwater Boats","b"],["Dargel Boats","b"],["Deep Impact Custom Boats","b"],["Donzi","b"],["Duckworth Boats","b"],["Dusky Marine","b"],["Eastern Boat Works","b"],["EdgeWater Power Boats","b"],["Everglades Boats","b"],["Evinrude","e"],["Finnmaster","b"],["Formula Boats","b"],["Fountain Powerboats","b"],["Four Winns","b"],["Freeman Boatworks","b"],["Galeon Yachts","b"],["Gause Built Custom Boats","b"],["Genesis Craft","b"],["Glacier Bay","b"],["Glastron","b"],["Godfrey Pontoons","b"],["Grady-White Boats","b"],["Grand Inflatable Boats","b"],["Hammer Yachts","b"],["Harris Pontoons","b"],["HCB Yachts","b"],["Hells Bay Boatworks","b"],["Hewes Craft","b"],["Honda Marine","e"],["Hurricane Boats","b"],["Hydra-Sports","b"],["Hysucat","b"],["Iguana Yachts","b"],["Insetta Boatworks","b"],["Intrepid Powerboats","b"],["Invictus Yacht","b"],["Invincible Boats","b"],["Jeanneau","b"],["Jupiter Marine","b"],["Key West Boats","b"],["KingFisher Boats","b"],["Larson Boats","b"],["LeisureCat","b"],["Life Proof Boats","b"],["Lund Boats","b"],["Majek Boats","b"],["MAKO Boats","b"],["Manitou Pontoons","b"],["Marauder Marine","b"],["Mares","b"],["MasterCraft","b"],["Mercury Marine","e"],["Metal Shark","b"],["Midnight Express","b"],["MJM Yachts","b"],["Monterey Boats","b"],["MTI","b"],["NauticStar Boats","b"],["Neptunus Yachts","b"],["Nimbus Boats","b"],["Nordkapp","b"],["North River Boats","b"],["Novurania","b"],["Ocean Alexander","b"],["OXE Marine","e"],["Paramount Powerboats","b"],["Parker Boats","b"],["Pathfinder Boats","b"],["PlayCraft Boats","b"],["Premier Pontoons","b"],["Princecraft","b"],["Pro-Line Boats","b"],["Pursuit Boats","b"],["Quicksilver Boats","b"],["Quintrex","b"],["Ranger Boats","b"],["Ranger Tugs","b"],["Reef Runner Boats","b"],["Regal Boats","b"],["Regulator Marine","b"],["RIBCRAFT","b"],["Rinker Boats","b"],["Robalo Boats","b"],["Rossborough Boats","b"],["SAFE Boats International","b"],["Sailfish Boats","b"],["Sanger Boats","b"],["Saxdor Yachts","b"],["Schaefer Yachts","b"],["Scout Boats","b"],["Sea Fox Boats","b"],["Sea Hunt Boats","b"],["Sea Ray","b"],["SeaHunter","b"],["SeaLegs","b"],["Seaswirl","b"],["SeaVee Boats","b"],["Silver Dolphin","b"],["Skagit Orca","b"],["Skeeter","b"],["Southport Boats","b"],["Sportsman Boats","b"],["Stabicraft","b"],["Stamas Yachts","b"],["Stanley Aluminum Boats","b"],["Starcraft Marine","b"],["Steiger Craft","b"],["Stingray Boats","b"],["SunCatcher Pontoons","b"],["Suzuki Marine","e"],["Tactical Custom Boats","b"],["Tahoe Boats","b"],["Targa","b"],["Thunder Jet","b"],["Tiara Yachts","b"],["Tidewater Boats","b"],["Titan Boats","b"],["Trophy Sportfishing Boats","b"],["Twin Vee PowerCats","b"],["Valhalla Boatworks","b"],["Vela Boatworks","b"],["Vexus Boats","b"],["Warrior Boats","b"],["Weldcraft","b"],["Wellcraft","b"],["World Cat","b"],["Xcursion Pontoons","b"],["Xpress Boats","b"],["Yamaha","e"],["Yellowfin","b"],["Zodiac Nautic","b"]];
  const form=root.querySelector('.home-find-form');
  const input=root.querySelector('#home-find-input');
  const list=root.querySelector('#home-find-datalist');
  const result=root.querySelector('.home-find-result');
  const icon=root.querySelector('.home-find-result-icon');
  const title=root.querySelector('.home-find-result-copy strong');
  const copy=root.querySelector('.home-find-result-copy p');
  const suggestions=root.querySelector('.home-find-suggestions');
  const normalize=s=>(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'');
  const entries=brands.map((b,i)=>({name:b[0],type:b[1],norm:normalize(b[0]),i}));
  entries.forEach(b=>{const o=document.createElement('option');o.value=b.name;list.appendChild(o);});

  function storeBrand(b){
    try{sessionStorage.setItem('sharrowSelectedBrand',JSON.stringify({name:b.name,type:b.type==='e'?'engine':'boat'}));}catch(e){}
  }
  function showBrand(b){
    storeBrand(b);
    result.hidden=false;
    result.classList.remove('not-found');
    icon.textContent='✓';
    title.textContent=b.name+' is represented.';
    copy.textContent=b.type==='e' ? `SHARROW™ has been delivered for customer boats powered by ${b.name}.` : `SHARROW™ has been delivered for customer boats from ${b.name}.`;
    suggestions.replaceChildren();
  }
  function showMissing(q){
    result.hidden=false;
    result.classList.add('not-found');
    icon.textContent='?';
    title.textContent=q ? q+' is not listed yet.' : 'Enter a boat or engine brand.';
    copy.textContent=q ? 'That does not mean we cannot fit your boat. Open Prop Finder and tell us about your exact setup.' : 'Start typing to search the brands represented in the SHARROW™ community.';
    suggestions.replaceChildren();
  }
  function showChoices(matches){
    result.hidden=false;
    result.classList.remove('not-found');
    icon.textContent='…';
    title.textContent='Choose your brand.';
    copy.textContent='We found several close matches.';
    suggestions.replaceChildren();
    matches.slice(0,5).forEach(b=>{
      const button=document.createElement('button');
      button.type='button';button.className='home-find-suggestion';button.textContent=b.name;
      button.addEventListener('click',()=>{input.value=b.name;showBrand(b);});
      suggestions.appendChild(button);
    });
  }
  function searchBrand(){
    const raw=input.value.trim();
    const q=normalize(raw);
    if(!q){showMissing('');return;}
    const exact=entries.find(b=>b.norm===q || b.norm===q.replace(/marine$/,''));
    if(exact){showBrand(exact);return;}
    const matches=entries.filter(b=>b.norm.includes(q)||q.includes(b.norm));
    if(matches.length===1){showBrand(matches[0]);return;}
    if(matches.length>1){showChoices(matches);return;}
    showMissing(raw);
  }
  form.addEventListener('submit',e=>{e.preventDefault();searchBrand();});
  input.addEventListener('change',()=>{if(input.value.trim()) searchBrand();});
})();
  window.SharrowCoverVideo(document.querySelector('.sharrow-home > .hero .hero-video'), '--sharrow');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSharrowHome,{once:true});
  else initSharrowHome();
  document.addEventListener('shopify:section:load',function(e){ if(e.target&&e.target.querySelector('.sharrow-home')) initSharrowHome(); });
})();
